const MODULE_NAME = 'ReportsModule';

export const ITEM_TO_EXCLUDE = `${MODULE_NAME}/ITEM_TO_EXCLUDE`;
export const TOGGLE_EXCLUDE_ITEMS = `${MODULE_NAME}/TOGGLE_EXCLUDE_ITEMS`;
export const SET_REPORT_TYPE = `${MODULE_NAME}/SET_REPORT_TYPE`;
export const REPORTS_SET_REOPRT_VIEW = `${MODULE_NAME}/SET_REPORT_VIEW`;
export const SET_EXCLUDED_ITEMS = `${MODULE_NAME}/SET_EXCLUDED_ITEMS`;
export const SET_GALLERY_IMAGES = `${MODULE_NAME}/SET_GALLERY_IMAGES`;
export const SET_GALLERY_START_INDEX = `${MODULE_NAME}/SET_GALLERY_START_INDEX`;
export const SET_SELECTED_PHASE_ID = `${MODULE_NAME}/SET_SELECTED_PHASE_ID`;
export const LOCAL_TOGGLE_INTERNAL_REPORT = 'TOGGLE_INTERNAL_REPORT';
export const LOCAL_SET_REPORT_TYPE = 'SET_REPORT_TYPE';
